import React, { useContext } from 'react'

const LayoutBooking = (props) => {
  return <div className="h-full z-10">{props.children}</div>
}

export default LayoutBooking
